import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  ButtonGroup,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  Row,
  Col,
  Tabs,
  Tab,
  ControlLabel,
  Glyphicon,
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {
  getContractList,
  getContractNotExecutedList,
  deleteContract,
  executeContract,
  uploadPhysicalContracts,
} from "../../../redux/actions/contractActions";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";
import { aclUtil } from "../../util";

const history = createBrowserHistory();
const options = [25, 50, 75, 100, 125, 150, 175, 200];
let merchantID = "";
class ContractList extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      menuKey: "LIST_CONTRACT",
      contractList: [],
      contractNotExecutedList: [],
      totalRecords: 0,
      limit: 25,
      selectedOption: options[0],
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      currentPageNotExecuted: 1,
      totalRecordsNotExecuted: 0,
      perPageNotExecuted: 0,
      pageCountNotExecuted: 0,
      alertMessage: "",
      msgType: "success",
      skuCodeIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      skuCodeOrderBy: "skuCode",
      offerTitleIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      merchantLegalNameIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      contactEmailIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      contactPhoneIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      skuCodesortOrder: "DESC",
      offerTitlesortOrder: "DESC",
      merchantsortOrder: "DESC",
      contactEmailsortOrder: "DESC",
      phonesortOrder: "DESC",
      path: ["Home", "Manage Contract"],
      links: ["home", "contractList"],
      show: false,
      uploadShow: false,
      contractID: "",
      modelContract: "",
      reasonForExecution: "",
      offerReasonForExecutionError: "",
      physical_contracts: "",
      physicalContractsForExecutionError: "",
      alert: false,
      orderby: "",
      direction: "",
      userType: localStorage.getItem("userTypeName"),
      uploadedContract: {},
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChangeExecution = this.handleChangeExecution.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleAlertShow = this.handleAlertShow.bind(this);
  }

  handleSelect(eventKey, event) {
    this.setState({
      selectedOption: options[eventKey],
      limit: options[eventKey],
    });
    const postData = {
      page: this.state.currentPage,
      limit: options[eventKey],
      search: this.state.search,
      merchantID: merchantID,
    };
    this.props.getContractList(postData);
    this.props.getContractList(postData);
    this.props.getContractNotExecutedList(postData);
  }

  handleChangeExecution(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleselectedFile = (event) => {
    this.setState({
      physical_contracts: event.target.files[0],
    });
  };

  handleDismiss() {
    this.setState({ alert: false });
  }

  handleAlertShow() {
    this.setState({ alert: true });
  }

  handleTabs = (data) => {
    if (data === 2) {
      this.props.getContractList({
        page: 1,
        merchantID: merchantID,
        limit: this.state.limit,
      });
    }
  };
  handleExecute() {
    if (this.state.reasonForExecution.length === 0) {
      this.setState({
        offerReasonForExecutionError: "Execution reason is required.",
      });
    } else {
      this.setState({ offerReasonForExecutionError: "" });
    }

    if (this.state.contractID !== "") {
      const postData = {
        reasonForExecution: this.state.reasonForExecution,
        contractID: this.state.contractID,
      };
      this.props.executeContract(postData);
      this.handleClose();
      // this.handlePageChange(this.state.currentPage);
    }
  }

  uploadExecute() {
    const formData = new FormData();
    formData.append("physical_contracts", this.state.physical_contracts);
    formData.append("contractID", this.state.contractID);
    if (this.state.contractID !== "") {
      this.props.uploadPhysicalContracts(formData);
      this.handleUploadClose();
      this.handlePageChange(this.state.currentPage);
    }
  }

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = e.target.value.length > 1 ? e.target.value : "";
    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      search: searchstring,
      merchantID: merchantID,
    };
    if (e.target.value.length !== 0) {
      this.props.getContractList(postData);
      this.props.getContractNotExecutedList(postData);
    } else {
      this.props.getContractList({
        page: this.state.currentPage,
        limit: this.state.limit,
        merchantID: merchantID,
      });
      this.props.getContractNotExecutedList({
        page: this.state.currentPage,
        merchantID: merchantID,
      });
    }
  }

  sorting(orderby, direction) {
    if (orderby === "skuCode" && direction === "DESC") {
      this.setState({ skuCodesortOrder: "ASC" });
      this.setState({ skuCodeIcon: "glyphicon glyphicon-sort-by-attributes" });
    } else {
      this.setState({ skuCodesortOrder: "DESC" });
      this.setState({
        skuCodeIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "offerTitle" && direction === "DESC") {
      this.setState({ offerTitlesortOrder: "ASC" });
      this.setState({
        offerTitleIcon: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ offerTitlesortOrder: "DESC" });
      this.setState({
        offerTitleIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "merchantLegalName" && direction === "DESC") {
      this.setState({ merchantsortOrder: "ASC" });
      this.setState({
        merchantLegalNameIcon: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ merchantsortOrder: "DESC" });
      this.setState({
        merchantLegalNameIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "contactEmail" && direction === "DESC") {
      this.setState({ contactEmailsortOrder: "ASC" });
      this.setState({
        contactEmailIcon: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ contactEmailsortOrder: "DESC" });
      this.setState({
        contactEmailIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "phone" && direction === "DESC") {
      this.setState({ phonesortOrder: "ASC" });
      this.setState({
        contactPhoneIcon: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ phonesortOrder: "DESC" });
      this.setState({
        contactPhoneIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    this.setState({ orderby: orderby });
    this.setState({ direction: direction });
    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      search: this.state.search,
      orderBy: orderby,
      direction: direction,
      merchantID: merchantID,
    };

    this.props.getContractList(postData);
  }

  NotExecutedsorting(orderby, direction) {
    if (orderby === "skuCode" && direction === "DESC") {
      this.setState({ skuCodesortOrder: "ASC" });
      this.setState({ skuCodeIcon: "glyphicon glyphicon-sort-by-attributes" });
    } else {
      this.setState({ skuCodesortOrder: "DESC" });
      this.setState({
        skuCodeIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "offerTitle" && direction === "DESC") {
      this.setState({ offerTitlesortOrder: "ASC" });
      this.setState({
        offerTitleIcon: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ offerTitlesortOrder: "DESC" });
      this.setState({
        offerTitleIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "merchantLegalName" && direction === "DESC") {
      this.setState({ merchantsortOrder: "ASC" });
      this.setState({
        merchantLegalNameIcon: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ merchantsortOrder: "DESC" });
      this.setState({
        merchantLegalNameIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "contactEmail" && direction === "DESC") {
      this.setState({ contactEmailsortOrder: "ASC" });
      this.setState({
        contactEmailIcon: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ contactEmailsortOrder: "DESC" });
      this.setState({
        contactEmailIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "phone" && direction === "DESC") {
      this.setState({ phonesortOrder: "ASC" });
      this.setState({
        contactPhoneIcon: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ phonesortOrder: "DESC" });
      this.setState({
        contactPhoneIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    this.setState({ orderby: orderby });
    this.setState({ direction: direction });
    const postData = {
      page: this.state.currentPageNotExecuted,
      limit: this.state.limit,
      search: this.state.search,
      orderBy: orderby,
      direction: direction,
      merchantID: merchantID,
    };

    this.props.getContractNotExecutedList(postData);
  }

  handlePageChange = (page) => {
    this.setState({
      currentPage: page,
    });
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.getContractList({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit: this.state.limit,
        merchantID: merchantID,
      });
    } else if (this.state.search !== "") {
      this.props.getContractList({
        page: page,
        search: this.state.search,
        limit: this.state.limit,
        merchantID: merchantID,
      });
    } else {
      this.props.getContractList({
        page: page,
        limit: this.state.limit,
        merchantID: merchantID,
      });
    }
  };

  handleNotExecutedPageChange = (page) => {
    this.setState({
      currentPageNotExecuted: page,
    });
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.getContractNotExecutedList({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit: this.state.limit,
        merchantID: merchantID,
      });
    } else if (this.state.search !== "") {
      this.props.getContractNotExecutedList({
        page: page,
        search: this.state.search,
        limit: this.state.limit,
        merchantID: merchantID,
      });
    } else {
      this.props.getContractNotExecutedList({
        page: page,
        limit: this.state.limit,
        merchantID: merchantID,
      });
    }
  };

  handleClose() {
    this.setState({
      show: false,
      reasonForExecution: "",
      contractID: "",
    });
  }

  handleShow(contractID) {
    this.setState({
      show: true,
      modelContract: "execute",
      contractID: contractID,
    });
  }

  handleUploadClose() {
    this.setState({
      uploadShow: false,
      physical_contracts: "",
      contractID: "",
    });
  }

  handleUploadShow(contractID) {
    this.setState({
      uploadShow: true,
      modelContract: "upload",
      contractID: contractID,
    });
  }

  handleUploadFile(physicalContracts) {
    window.location.assign(physicalContracts);
  }

  componentDidMount() {}

  componentWillMount() {
    merchantID =
      this.props.match.params && this.props.match.params.merchantID
        ? this.props.match.params.merchantID
        : "";
    this.props.clearAlert();
    this.handleDismiss();

    //this.props.getContractList({page:1, merchantID : merchantID, limit : this.state.limit});
    this.props.getContractNotExecutedList({
      page: 1,
      merchantID: merchantID,
      limit: this.state.limit,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)) {
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.contractList !== nextProps.contractList) {
      if (nextProps.contractList) {
        const setPageCount =
          nextProps.contractList.total / nextProps.contractList.per_page;
        this.setState({
          contractList: nextProps.contractList.data,
          totalRecords: nextProps.contractList.total,
          perPage: nextProps.contractList.per_page,
          pageCount: 5,
        });
      }
    }

    if (
      this.props.contractNotExecutedList !== nextProps.contractNotExecutedList
    ) {
      if (nextProps.contractNotExecutedList) {
        const setPageCount =
          nextProps.contractNotExecutedList.total /
          nextProps.contractNotExecutedList.per_page;
        this.setState({
          contractNotExecutedList: nextProps.contractNotExecutedList.data,
          totalRecordsNotExecuted: nextProps.contractNotExecutedList.total,
          perPageNotExecuted: nextProps.contractNotExecutedList.per_page,
          pageCountNotExecuted: 5,
        });
      }
    }

    if (!isEmpty(this.props.executedContract)) {
      this.setState({
        alertMessage: this.props.executedContract.message,
        msgType: "success",
      });
    }

    if (this.props.executedContract !== nextProps.executedContract) {
      if (nextProps.executedContract) {
        this.context.router.history.push(
          `/editDeal/${nextProps.executedContract.data}`
        );
      }
    }
    if (this.props.deletedContract !== nextProps.deletedContract) {
      if (nextProps.deletedContract) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleAlertShow();
        this.props.renderAlert("success", nextProps.deletedContract.message);
        this.props.getContractList({
          page: this.state.currentPage,
          limit: this.state.limit,
          merchantID: merchantID,
        });
        this.props.getContractNotExecutedList({
          page: this.state.currentPage,
          limit: this.state.limit,
          merchantID: merchantID,
        });
      }
    }
    if (this.props.error !== nextProps.error && !isEmpty(nextProps.error)) {
      this.setState({ alert: false });
      this.props.clearAlert();
      this.handleAlertShow();
      this.props.renderAlert("warning", nextProps.error);
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
    }

    if (this.props.executedContract !== nextProps.executedContract) {
      if (nextProps.executedContract) {
        this.handlePageChange(this.state.currentPage);
      }
    }

    if (this.props.uploadedContract !== nextProps.uploadedContract) {
      if (nextProps.uploadedContract) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleAlertShow();
        this.props.renderAlert("success", nextProps.uploadedContract.message);
      }
    }
  }

  handleDelete = (contractID) => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(contractID);
        }),
      ],
    });
  };

  confirmDelete = (contractID) => {
    this.props.deleteContract(contractID);
  };

  render() {
    const { path } = this.state;
    const {
      currentPage,
      totalRecords,
      perPage,
      pageCount,
      currentPageNotExecuted,
      totalRecordsNotExecuted,
      perPageNotExecuted,
      pageCountNotExecuted,
    } = this.state;

    let contractExecutedRow, contractNotExecutedRow;

    if (!isEmpty(this.state.contractList)) {
      contractExecutedRow = this.state.contractList.map((contract, index) => (
        <tr key={contract.contractID}>
          {/*<td>{contract.skuCode}</td>*/}
          <td>{contract.offerTitle}</td>
          <td>{contract.merchantLegalName}</td>
          <td>{contract.contactEmail}</td>
          <td>{contract.registeredOn}</td>
          {/*<td>{(contract.dealID) ? 'Executed' : 'Not Executed'}</td>*/}
          <td>
            <ButtonGroup>
              <DropdownButton title="Action" id="bg-nested-dropdown">
                {!contract.dealID &&
                  aclUtil.checkACL("EXECUTE_CONTRACT") &&
                  this.state.userType !== "finance" && (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.handleShow.bind(this, contract.contractID)}
                    >
                      <i className="glyphicon glyphicon-cloud"></i> Execute
                    </MenuItem>
                  )}
                {!contract.dealID &&
                aclUtil.checkACL("MAIL_TO_MERCHANT_CONTRACT") ? (
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={() =>
                      this.context.router.history.push(
                        `/contract-mail/${contract.contractID}/${contract.merchantID}`
                      )
                    }
                  >
                    <i className="glyphicon glyphicon-send"></i> Send Mail
                  </MenuItem>
                ) : (
                  ""
                )}
                {contract.dealID && aclUtil.checkACL("VIEW_CONTRACT") && (
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={() =>
                      this.context.router.history.push(
                        `/contractDetails/${contract.contractID}`
                      )
                    }
                  >
                    <i className="glyphicon glyphicon-eye-open"></i> View
                  </MenuItem>
                )}
                {aclUtil.checkACL("EDIT_CONTRACT") &&
                this.state.userType !== "finance" ? (
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={() =>
                      this.context.router.history.push(
                        `/addContract/${contract.contractID}/edit`
                      )
                    }
                  >
                    <i className="glyphicon glyphicon-pencil"></i> Edit
                  </MenuItem>
                ) : (
                  ""
                )}
                {aclUtil.checkACL("DELETE_CONTRACT") &&
                this.state.userType !== "finance" ? (
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.handleDelete.bind(this, contract.contractID)}
                  >
                    <i className="glyphicon glyphicon-trash"></i> Delete
                  </MenuItem>
                ) : (
                  ""
                )}
                {contract.merchantID && this.state.userType !== "finance" && (
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={() =>
                      this.context.router.history.push(
                        `/merchant/dashboard/${contract.uID}`
                      )
                    }
                  >
                    <i className="glyphicon glyphicon-eye-open"></i>Merchant
                    Dashboard
                  </MenuItem>
                )}
                {contract.contractID &&
                  this.state.userType !== "finance" &&
                  isEmpty(contract.physical_contracts) && (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.handleUploadShow.bind(
                        this,
                        contract.contractID
                      )}
                    >
                      <i className="glyphicon glyphicon-file"></i> Upload
                      Contract
                    </MenuItem>
                  )}
                {contract.contractID &&
                  this.state.userType !== "finance" &&
                  !isEmpty(contract.physical_contracts) && (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.handleUploadFile.bind(
                        this,
                        contract.physical_contracts
                      )}
                    >
                      <i className="glyphicon glyphicon-file"></i> Download
                      Contract
                    </MenuItem>
                  )}
              </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }

    if (!isEmpty(this.state.contractNotExecutedList)) {
      contractNotExecutedRow = this.state.contractNotExecutedList.map(
        (contract, index) => (
          <tr key={contract.contractID}>
            <td>{contract.offerTitle}</td>
            <td>{contract.merchantLegalName}</td>
            <td>{contract.contactEmail}</td>
            <td>{contract.registeredOn}</td>
            <td>
              <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {!contract.dealID &&
                    aclUtil.checkACL("EXECUTE_CONTRACT") &&
                    this.state.userType !== "finance" && (
                      <MenuItem
                        eventKey={Math.random()}
                        onClick={this.handleShow.bind(
                          this,
                          contract.contractID
                        )}
                      >
                        <i className="glyphicon glyphicon-cloud"></i> Execute
                      </MenuItem>
                    )}
                  {!contract.dealID &&
                  aclUtil.checkACL("MAIL_TO_MERCHANT_CONTRACT") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/contract-mail/${contract.contractID}/${contract.merchantID}`
                        )
                      }
                    >
                      <i className="glyphicon glyphicon-send"></i> Send Mail
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {contract.dealID && aclUtil.checkACL("VIEW_CONTRACT") && (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/contractDetails/${contract.contractID}`
                        )
                      }
                    >
                      <i className="glyphicon glyphicon-eye-open"></i> View
                    </MenuItem>
                  )}
                  {aclUtil.checkACL("EDIT_CONTRACT") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${contract.contractID}/edit`
                        )
                      }
                    >
                      <i className="glyphicon glyphicon-pencil"></i> Edit
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("DELETE_CONTRACT") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.handleDelete.bind(
                        this,
                        contract.contractID
                      )}
                    >
                      <i className="glyphicon glyphicon-trash"></i> Delete
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {contract.merchantID && this.state.userType !== "finance" && (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/merchant/dashboard/${contract.uID}`
                        )
                      }
                    >
                      <i className="glyphicon glyphicon-eye-open"></i>Merchant
                      Dashboard
                    </MenuItem>
                  )}
                </DropdownButton>
              </ButtonGroup>
            </td>
          </tr>
        )
      );
    }

    return (
      <div>
        <Dialog
          ref={(el) => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent
                path={this.state.path}
                links={this.state.links}
                context={this.context}
              />
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading panel-heading-index">
              <div className="row">
                <div className="col-lg-6 col-md-4 col-sm-12">
                  <h4>Contract List</h4>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="search"
                        onKeyUp={this.handleSearch}
                      />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12">
                  <DropdownButton
                    bsSize="small"
                    bsStyle="default"
                    title={this.state.selectedOption}
                    onSelect={this.handleSelect}
                    id="0"
                  >
                    {options.map((opt, i) => (
                      <MenuItem key={i} eventKey={i}>
                        {opt}
                      </MenuItem>
                    ))}
                  </DropdownButton>
                  {aclUtil.checkACL("ADD_CONTRACT") ? (
                    <Button
                      className="addMerchant"
                      bsSize="small"
                      bsStyle="success"
                      onClick={() =>
                        this.context.router.history.push("/addContract")
                      }
                    >
                      + Add Contract
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </header>
            <div className="panel-body">
              {this.state.alert && this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}

              <div className="row">
                <div className="col-lg-12">
                  <Row>
                    <Col xs={12} md={12}>
                      <Tabs
                        activeKey={this.state.key}
                        onSelect={this.handleTabs}
                        id="controlled-tab-example"
                      >
                        <Tab eventKey={1} title="Pending Contracts">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th
                                  onClick={this.NotExecutedsorting.bind(
                                    this,
                                    "offerTitle",
                                    this.state.offerTitlesortOrder
                                  )}
                                >
                                  Offer Title{" "}
                                  <i className={this.state.offerTitleIcon} />
                                </th>
                                <th
                                  onClick={this.NotExecutedsorting.bind(
                                    this,
                                    "merchantLegalName",
                                    this.state.merchantsortOrder
                                  )}
                                >
                                  Merchant Legal Name{" "}
                                  <i
                                    className={this.state.merchantLegalNameIcon}
                                  />
                                </th>
                                <th
                                  onClick={this.NotExecutedsorting.bind(
                                    this,
                                    "contactEmail",
                                    this.state.contactEmailsortOrder
                                  )}
                                >
                                  Contact Email{" "}
                                  <i className={this.state.contactEmailIcon} />
                                </th>
                                <th>Contract Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>{contractNotExecutedRow}</tbody>
                          </table>
                          <div className="text-center">
                            <Pagination
                              total={totalRecordsNotExecuted}
                              limit={perPageNotExecuted}
                              pageCount={pageCountNotExecuted}
                              currentPage={currentPageNotExecuted}
                            >
                              {({
                                pages,
                                currentPage,
                                hasNextPage,
                                hasPreviousPage,
                                previousPage,
                                nextPage,
                                totalPages,
                                getPageItemProps,
                              }) => (
                                <div className="pagination">
                                  <button
                                    className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: 1,
                                      onPageChange:
                                        this.handleNotExecutedPageChange,
                                    })}
                                  >
                                    first
                                  </button>

                                  {hasPreviousPage && (
                                    <button
                                      className="btn btn-default"
                                      {...getPageItemProps({
                                        pageValue: previousPage,
                                        onPageChange:
                                          this.handleNotExecutedPageChange,
                                      })}
                                    >
                                      {"<"}
                                    </button>
                                  )}

                                  {pages.map((page) => {
                                    let activePage = null;
                                    if (currentPage === page) {
                                      activePage = {
                                        backgroundColor: "#ccc",
                                        color: "#666",
                                      };
                                    }
                                    return (
                                      <button
                                        className="btn btn-default"
                                        key={page}
                                        style={activePage}
                                        {...getPageItemProps({
                                          pageValue: page,
                                          onPageChange:
                                            this.handleNotExecutedPageChange,
                                        })}
                                      >
                                        {page}
                                      </button>
                                    );
                                  })}

                                  {hasNextPage && (
                                    <button
                                      className="btn btn-default"
                                      {...getPageItemProps({
                                        pageValue: nextPage,
                                        onPageChange:
                                          this.handleNotExecutedPageChange,
                                      })}
                                    >
                                      {">"}
                                    </button>
                                  )}

                                  <button
                                    className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: totalPages,
                                      onPageChange:
                                        this.handleNotExecutedPageChange,
                                    })}
                                  >
                                    last
                                  </button>
                                </div>
                              )}
                            </Pagination>
                          </div>
                        </Tab>
                        <Tab eventKey={2} title="Executed Contracts">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th
                                  onClick={this.sorting.bind(
                                    this,
                                    "offerTitle",
                                    this.state.offerTitlesortOrder
                                  )}
                                >
                                  Offer Title{" "}
                                  <i className={this.state.offerTitleIcon} />
                                </th>
                                <th
                                  onClick={this.sorting.bind(
                                    this,
                                    "merchantLegalName",
                                    this.state.merchantsortOrder
                                  )}
                                >
                                  Merchant Legal Name{" "}
                                  <i
                                    className={this.state.merchantLegalNameIcon}
                                  />
                                </th>
                                <th
                                  onClick={this.sorting.bind(
                                    this,
                                    "contactEmail",
                                    this.state.contactEmailsortOrder
                                  )}
                                >
                                  Contact Email{" "}
                                  <i className={this.state.contactEmailIcon} />
                                </th>
                                <th>Contract Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>{contractExecutedRow}</tbody>
                          </table>
                          <div className="text-center">
                            <Pagination
                              total={totalRecords}
                              limit={perPage}
                              pageCount={5}
                              currentPage={currentPage}
                            >
                              {({
                                pages,
                                currentPage,
                                hasNextPage,
                                hasPreviousPage,
                                previousPage,
                                nextPage,
                                totalPages,
                                getPageItemProps,
                              }) => (
                                <div className="pagination">
                                  <button
                                    {...getPageItemProps({
                                      pageValue: 1,
                                      onPageChange: this.handlePageChange,
                                    })}
                                  >
                                    first
                                  </button>

                                  {hasPreviousPage && (
                                    <button
                                      {...getPageItemProps({
                                        pageValue: previousPage,
                                        onPageChange: this.handlePageChange,
                                      })}
                                    >
                                      {"<"}
                                    </button>
                                  )}

                                  {pages.map((page) => {
                                    let activePage = null;
                                    if (currentPage === page) {
                                      activePage = {
                                        backgroundColor: "#ccc",
                                        color: "#666",
                                      };
                                    }
                                    return (
                                      <button
                                        key={page}
                                        style={activePage}
                                        {...getPageItemProps({
                                          pageValue: page,
                                          onPageChange: this.handlePageChange,
                                        })}
                                      >
                                        {page}
                                      </button>
                                    );
                                  })}

                                  {hasNextPage && (
                                    <button
                                      {...getPageItemProps({
                                        pageValue: nextPage,
                                        onPageChange: this.handlePageChange,
                                      })}
                                    >
                                      {">"}
                                    </button>
                                  )}

                                  <button
                                    {...getPageItemProps({
                                      pageValue: totalPages,
                                      onPageChange: this.handlePageChange,
                                    })}
                                  >
                                    last
                                  </button>
                                </div>
                              )}
                            </Pagination>
                          </div>
                        </Tab>
                      </Tabs>
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
        {this.state.modelContract == "execute" && (
          <Modal show={this.state.show} onHide={this.handleClose.bind(this)}>
            <Modal.Header closeButton>
              <Modal.Title>Execution Process</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form>
                <FormGroup controlId="formTermsAndConditions">
                  <ControlLabel>Execution Reason</ControlLabel>
                  <FormControl
                    value={this.state.reasonForExecution}
                    componentClass="textarea"
                    onChange={this.handleChangeExecution}
                    name="reasonForExecution"
                    placeholder="Execution Reason"
                  />
                </FormGroup>
                <p className="inline-validation-error">
                  {this.state.offerReasonForExecutionError !== ""
                    ? this.state.offerTitleError
                    : " "}
                </p>
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="success" onClick={this.handleExecute.bind(this)}>
                Execute
              </Button>
              <Button bsStyle="danger" onClick={this.handleClose.bind(this)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        <Modal
          show={this.state.uploadShow}
          onHide={this.handleUploadClose.bind(this)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Upload Contract</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <FormGroup controlId="formUploadContract">
                <ControlLabel>Upload</ControlLabel>
                <FormControl
                  type="file"
                  onChange={this.handleselectedFile}
                  name="physical_contracts"
                />
              </FormGroup>
              <p className="inline-validation-error">
                {this.state.physicalContractsForExecutionError !== ""
                  ? this.state.offerTitleError
                  : " "}
              </p>
              <span
                className="text-danger"
                style={{ fontSize: "12px", textTransform: "none" }}
              >
                (Upload Contract file type: doc, docx, pdf)
              </span>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.uploadExecute.bind(this)}>
              Upload
            </Button>
            <Button
              bsStyle="danger"
              onClick={this.handleUploadClose.bind(this)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

ContractList.propTypes = {
  getContractList: PropTypes.func.isRequired,
  getContractNotExecutedList: PropTypes.func.isRequired,
  deleteContract: PropTypes.func.isRequired,
  executeContract: PropTypes.func.isRequired,
  uploadPhysicalContracts: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  contractList: state.contractReducer.contractList,
  contractNotExecutedList: state.contractReducer.contractNotExecutedList,
  deletedContract: state.contractReducer.deletedContract,
  executedContract: state.contractReducer.executedContract,
  uploadedContract: state.contractReducer.uploadPhysicalContracts,
  error: state.contractReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
});

export default withRouter(
  connect(mapStateToProps, {
    getContractList,
    getContractNotExecutedList,
    executeContract,
    uploadPhysicalContracts,
    deleteContract,
    renderAlert,
    clearAlert,
  })(ContractList)
);



// WEBPACK FOOTER //
// ./src/app/views/admin/contract/ContractList.js